angular.module('wbDashboard').controller('PlansDetailFeatureFindYourLimitModalAurea', ['$scope', '$uibModal', function ($scope, $uibModal) {

    $scope.findYourLimitModal = function() {
        var $modalScope = $scope.$new();
        $modalScope.date = moment();

        var modalInstance = $uibModal.open({
            templateUrl: "app/themes/aurea/segments/plans/plans/taxplan/features/taxpreferredaccount/modal.taxpreferredaccount.find-your-limit.tpl.html",
            size: 'md',
            scope: $modalScope,
            windowClass: 'confirm-modal'
        });

        modalInstance.result.then(function (plan) {
        }).catch(angular.noop).finally(function() {
        });

    };

}]);
